import { useEffect } from 'react';
import { LocalStorageCache } from '@brighte/passwordless-authenticator';
import { QuoteStatus as Status } from '@graphql/index';
import ApplicationForm from '@pages/ApplicationForm/ApplicationForm';
import { Box } from '@spark-web/box';
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { QUOTE_STATUSES, accessibleQuote } from '@utils';

function QuoteStatusPage({ status }: { status: Status | undefined }) {
  useEffect(() => {
    if (status === Status.EXPIRED || status === Status.CANCELLED) {
      const cache = new LocalStorageCache();
      cache.removeAll();
    }
  }, [status]);

  if (!status || accessibleQuote(status)) {
    return <ApplicationForm />;
  }

  const { icon, title, message } = QUOTE_STATUSES[status];

  return (
    <Stack align="center" gap="xxlarge">
      {icon}
      <Heading level="1" align="center">
        {title}
      </Heading>
      <Box as="div" margin="xlarge" gap="large">
        <Text align="center" size="large" tone="muted">
          {message}
        </Text>
      </Box>
    </Stack>
  );
}

export default QuoteStatusPage;
